/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Fragment, useLayoutEffect, useRef, useState, useEffect, useContext } from 'react'
import { useParams, useLocation, useHistory } from 'react-router-dom';
import { Menu, Dialog, Transition } from '@headlessui/react'
import { get, ref, onValue, startAt, orderByKey, limitToFirst, query } from "firebase/database";
import axios from "axios";
import ReactJson from 'react18-json-view';
import 'react18-json-view/src/style.css'
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { ArrowLongLeftIcon, ArrowLongRightIcon, ChevronDownIcon, ChevronRightIcon, XMarkIcon } from '@heroicons/react/20/solid';
import { CheckCircleIcon, ExclamationCircleIcon, ExclamationTriangleIcon, ChevronUpIcon, ChevronDownIcon as SortChevronDownIcon } from '@heroicons/react/24/outline'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExcel, faFileCsv, faCode, faRefresh, faEdit as IconEdit } from '@fortawesome/free-solid-svg-icons'
import { PlusIcon, TrashIcon } from '@heroicons/react/20/solid'
import { CalendarIcon, DocumentTextIcon, GlobeAltIcon, AdjustmentsHorizontalIcon, CodeBracketIcon, CodeBracketIcon as CustomCodeIcon } from '@heroicons/react/24/outline';
import { PencilIcon } from '@heroicons/react/20/solid'

import { AuthContext } from "../../utils/auth.js";
import CreateExtraction from '../../components/CreateExtraction.js';
import ModalForNewExtraction from '../../components/utils/ModalForNewExtraction.js';
import ModalForViewFile from '../../components/utils/ModalForViewFile.js';
import { handleGenerateJson, handleGenerateExcel, handleGenerateCsv, handleGenerateWord } from '../../components/functions/exportData.js';
import { db } from '../../utils/firebaseApp.js';
import Breadcrumb from './Components/ClassificationBreadcrumb.js';

import BatchHeading from './BatchFolder/BatchHeading.js';
import SelectFileStatus from './BatchFolder/SelectFileStatus.js';
import Pagination from './BatchFolder/Pagination.js';
import JsonViewerWindow from './BatchFolder/JsonViewer.js';
import { GoodNotificationCustom, ErrorNotificationCustom, GoodNotification, ErrorNotification } from './BatchFolder/Notifications.js';
import { ShowDeleteModalBatch, ShowDeleteModalFile, ShowDeleteModalFiles, ShowRedoModalFiles } from './BatchFolder/Modals.js';
import { DropdownWithDividerAndIcons, DropdownWithIcons } from './BatchFolder/Dropdowns.js';
import { LinkIcon, AlertCircle, CheckCircle, Search } from 'lucide-react';

import toast from 'react-hot-toast';
import { EditClassificationModal } from './Components/EditClassificationModal.js';

import { UploadFilesModal } from './Components/UploadFilesModal.js';

import ViewFile from './Components/ViewFile.js';

function classNames(...classes) { return classes.filter(Boolean).join(' ') }

export default function BatchScreen() {
  const { currentUser } = useContext(AuthContext);
  const location = useLocation();
  const history = useHistory();

  const adminEmails = ['barzoiu.alexandru@gmail.com', "alexraducu03@gmail.com"];
  const isAdmin = adminEmails.includes(currentUser.email);

  const [adminUserId, setAdminUserId] = useState('');
  const [searchedUserId, setSearchedUserId] = useState('');

  // Load admin user ID from URL on mount
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const adminUserIdParam = queryParams.get('adminUserId');

    if (isAdmin && adminUserIdParam) {
      setSearchedUserId(adminUserIdParam);
      setAdminUserId(adminUserIdParam);
    }
  }, [isAdmin, location.search]);

  // Use searchedUserId if admin has searched, otherwise use current userId
  const targetUserId = (isAdmin && searchedUserId) ? searchedUserId : currentUser.uid;
  let userId = targetUserId;

  const serverUrl = process.env.REACT_APP_SERVER_URL;
  const environment = process.env.REACT_APP_ENV;

  const [isLoading, setIsLoading] = useState(true);

  const { batchId, classificationId } = useParams();
  const [classification, setClassification] = useState({});

  const extractionId = 'TEST_EXTRACTION_ID';
  const [files, setFiles] = useState([]);
  const [allFilesFromCategory, setAllFilesFromCategory] = useState([]);
  const [fields, setFields] = useState([]);
  const [extraction, setExtraction] = useState();
  const [batch, setBatch] = useState();

  const [itemsPerPage, setItemsPerPage] = useState(20);
  const maxCharactersForField = 75;
  const maxCharactersForFieldObject = 50;
  const [currentPage, setCurrentPage] = useState(1);
  const [noOfPages, setNoOfPages] = useState(0);

  const [showFileBool, setShowFileBool] = useState(false);

  const [tabs, setTabs] = useState([
    { name: 'All', count: 0 },
    { name: 'Classified', count: 0 },
    { name: 'Unclassified', count: 0 },
    { name: 'Error', count: 0 },
  ]);

  const [currentTab, setCurrentTab] = useState('All');

  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const [showDelete, setShowDelete] = useState(false);

  const [showDeleteFile, setShowDeleteFile] = useState(false);
  const [selectedFileIdDelete, setSelectedFileIdDelete] = useState(null);

  const [showDeleteFiles, setShowDeleteFiles] = useState(false);

  const [showRedoFiles, setShowRedoFiles] = useState(false);

  const [showErrorCustom, setShowErrorCustom] = useState(false);
  const [errorCustomTitle, setErrorCustomTitle] = useState('');
  const [errorCustomSubtitle, setErrorCustomSubtitle] = useState('');

  const [showSuccessCustom, setShowSuccessCustom] = useState(false);
  const [successCustomTitle, setSuccessCustomTitle] = useState('');
  const [successCustomSubtitle, setSuccessCustomSubtitle] = useState('');

  const [selectAllFromBatch, setSelectAllFromBatch] = useState(false);
  const [isExporting, setIsExporting] = useState(false);

  const checkbox = useRef()
  const [checked, setChecked] = useState(false)
  const [indeterminate, setIndeterminate] = useState(false)
  const [selectedFiles, setSelectedFiles] = useState([])

  const [exportFormat, setExportFormat] = useState('excel');

  // Sorting state
  const [sortField, setSortField] = useState(null);
  const [sortDirection, setSortDirection] = useState('desc'); // 'asc' or 'desc'

  useLayoutEffect(() => {
    const isIndeterminate = selectedFiles.length > 0 && selectedFiles.length < allFilesFromCategory.length
    setChecked(selectedFiles.length === allFilesFromCategory.length && allFilesFromCategory.length > 0)
    setIndeterminate(isIndeterminate)
    checkbox.current.indeterminate = isIndeterminate
    //console.log("selectedFiles", selectedFiles);
  }, [selectedFiles, allFilesFromCategory])

  function toggleAll() {
    //console.log(files);
    setSelectedFiles(checked || indeterminate ? [] : files)
    setChecked(!checked && !indeterminate)
    setIndeterminate(false)
  }

  function resetSelectedFiles() {
    setSelectedFiles([]);
    setChecked(false);
    setIndeterminate(false);
    checkbox.current.indeterminate = false;
  }

  // Sorting function
  const handleSort = (field) => {
    if (sortField === field) {
      // Cycle through: desc -> asc -> no sort
      if (sortDirection === 'desc') {
        setSortDirection('asc');
      } else {
        // Reset to no sorting
        setSortField(null);
        setSortDirection('desc');
      }
    } else {
      // New field, start with descending
      setSortField(field);
      setSortDirection('desc');
    }
  };

  // Sort files function
  const sortFiles = (filesToSort) => {
    if (!sortField) return filesToSort;

    return [...filesToSort].sort((a, b) => {
      if (sortField === 'confidence') {
        const aConfidence = a.result?.confidence;
        const bConfidence = b.result?.confidence;

        // Files without confidence score come first
        if (aConfidence === undefined && bConfidence === undefined) return 0;
        if (aConfidence === undefined) return -1;
        if (bConfidence === undefined) return 1;

        // Sort by confidence value
        if (sortDirection === 'desc') {
          return bConfidence - aConfidence;
        } else {
          return aConfidence - bConfidence;
        }
      }
      return 0;
    });
  };

  const nextPage = () => {
    setCurrentPage(currentPage + 1);
    resetSelectedFiles();
  }

  const previousPage = () => {
    setCurrentPage(currentPage - 1);
    resetSelectedFiles();
  }

  const selectPage = (pageNumber) => {
    if (currentPage === pageNumber) {
      return;
    } else {
      setCurrentPage(pageNumber);
      resetSelectedFiles();
    }
  }

  const fetchClassification = async () => {
    // Use searchedUserId if admin has searched, otherwise use current userId
    const targetUserId = (isAdmin && searchedUserId) ? searchedUserId : currentUser.uid;
    let userId = targetUserId;

    // References for extraction and batch data
    const classificationRef = ref(db, `document_classification/classifications/${userId}/${classificationId}`);
    const batchesRef = ref(db, `document_classification/batches/${userId}/${classificationId}`); // Updated path for batches

    try {
      const [classificationSnapshot, batchesSnapshot] = await Promise.all([
        get(classificationRef),
        get(batchesRef)
      ]);

      if (classificationSnapshot.exists()) {
        const classificationData = classificationSnapshot.val();
        const batchesData = batchesSnapshot.exists() ? batchesSnapshot.val() : {};

        // Merge batches into the extractionData
        classificationData.batches = batchesData;

        classificationData.id = classificationId;
        setClassification(classificationData);
        //console.log(classificationData);

        // Set the specific batch being viewed
        const currentBatch = batchesData[batchId] ?? null;
        setBatch(currentBatch);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const [unsubscribeFilesListener, setUnsubscribeFilesListener] = useState(null);

  const loadFiles = () => {
    setIsLoading(true);
    setFiles([]);

    // Define the path to query all files for a specific user's extraction and batch
    let queryPath = 'document_classification/files/' + userId + '/' + classificationId + '/' + batchId;
    let itemsRef = ref(db, queryPath);

    // Query all files under the specified path
    const unsubscribe = onValue(itemsRef, (snapshot) => {
      const data = snapshot.val();
      let tempFiles = [];

      let countClassified = 0;
      let countUnclassified = 0;
      let countAll = 0;
      let countError = 0;
      let documentTypes = {};

      if (data) {

        //loop over classification.documentTypes and add the documentType to the documentTypes object
        if (classification?.documentTypes) {
          classification.documentTypes.forEach((documentType) => {
            documentTypes[documentType.name] = 0;
          })
        }

        //initial loop to get all document types
        // Object.keys(data).forEach((key) => {
        //   let file = data[key];
        //   //if document type is not in the array, add it
        //   //every object in documentTypes is of this
        //   if (file.result?.documentType) {
        //     if (!documentTypes[file.result.documentType]) {
        //       documentTypes[file.result.documentType] = 1;
        //     } else {
        //       documentTypes[file.result.documentType]++;
        //     }
        //   }
        // })

        //console.log("before", documentTypes);

        // Loop over each file in the data
        Object.keys(data).forEach((key) => {
          let file = data[key];
          file.id = key;

          // Create a new file object
          let newFile = {
            id: file.id,
            name: file.name ?? 'undefined',
            url: file.url,
            status: file.status,
            errorMessage: file.errorMessage || "",
            result: file.result ?? {},
            coordinates: file.coordinates ?? {},
            documentInfo: file.documentInfo ?? {},
            extraction: file.extraction ?? {},
          }

          //console.log(newFile);


          // Filter files based on the current tab and status
          if (currentTab === 'Classified' || currentTab === 'Unclassified' || currentTab === 'All' || currentTab === 'Error') {
            if (currentTab === 'All' && (file.status === 'processed' || file.status === 'error' || file.status === 'waiting')) {
              tempFiles.push(newFile);
            } else if (currentTab === 'Classified' && file.status === 'processed' && file.result?.documentType !== 'other') {
              tempFiles.push(newFile);
            } else if (currentTab === 'Unclassified' && file.result?.documentType === 'other' && file.status === 'processed') {
              tempFiles.push(newFile);
            } else if (currentTab === 'Error' && file.status === 'error') {
              tempFiles.push(newFile);
            }

          } else {
            //filter dinamically based on the document type
            //loop over the documentTypes object and check if the file.result.documentType is equal to the key
            for (const [key, value] of Object.entries(documentTypes)) {
              if (currentTab === key && file.result?.documentType === key) {
                tempFiles.push(newFile);
              }
            }
          }

          // Filter files based on document type


          // Increment the counters based on the file status
          if (file.status === 'processed' && file.result.documentType !== 'other') countClassified++;
          if (file.result?.documentType === 'other') countUnclassified++;
          //increment documentTypes[file.result.documentType]
          if (file.result?.documentType && Object.keys(documentTypes).find(key => key === file.result.documentType)) {
            documentTypes[file.result.documentType]++;
          }
          if (file.status === 'error') countError++;
          if (file.status === 'waiting' || file.status === 'processed' || file.status === 'error') countAll++;
        });
        //countAll = countClassified + countUnclassified + countError;
        //console.log("after", documentTypes);
        let totalItems = tempFiles.length;
        let tempNoOfPages = Math.ceil(totalItems / itemsPerPage);
        setNoOfPages(tempNoOfPages);

        // Ensure current page is valid and adjust if necessary
        if (currentPage > tempNoOfPages) {
          setCurrentPage(tempNoOfPages > 0 ? tempNoOfPages : 1);
        }

        // Apply sorting if a sort field is selected
        tempFiles = sortFiles(tempFiles);

        setAllFilesFromCategory(tempFiles);

        let start = (currentPage - 1) * itemsPerPage;
        let end = start + itemsPerPage;
        // Slice the array to get the current page of items
        tempFiles = tempFiles.slice(start, end);

        // Update the state with the fetched files
        if (tempFiles.length === 0) {
          setShowFileBool(false);
        }
        setFiles(tempFiles);


        let tempTabs = [];
        tempTabs.push({ name: 'All', count: countAll });
        tempTabs.push({ name: 'Classified', count: countClassified });
        tempTabs.push({ name: 'Unclassified', count: countUnclassified });
        tempTabs.push({ name: 'Error', count: countError });
        for (const [key, value] of Object.entries(documentTypes)) {
          tempTabs.push({ name: key, count: value });
        }

        // Update the tabs state with the new counts
        setTabs(tempTabs);

        setIsLoading(false);
      }
    });

    // Set a function to unsubscribe from the database updates when needed
    setUnsubscribeFilesListener(() => unsubscribe);
  }

  const loadAllFiles = async () => {
    // Use searchedUserId if admin has searched, otherwise use current userId
    const targetUserId = (isAdmin && searchedUserId) ? searchedUserId : currentUser.uid;
    let userId = targetUserId;
    const databaseRef = ref(db, 'files/' + userId + '/' + extractionId + '/' + batchId);

    try {
      const snapshot = await get(databaseRef);

      if (snapshot.exists()) {
        const data = snapshot.val();
        return data;
      }
    } catch (error) {
      // console.error("Error fetching data:", error);
    }
  }

  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      await fetchClassification();
    }
    fetchData();
    resetSelectedFiles();
  }, [classificationId, batchId, searchedUserId, isAdmin]);

  useEffect(() => {
    if (classification) {
      if (unsubscribeFilesListener) {
        unsubscribeFilesListener();
      }

      loadFiles();
    }

    return () => {
      if (unsubscribeFilesListener) {
        unsubscribeFilesListener();
      }
    };
  }, [currentPage, classification, currentTab, itemsPerPage, refresh, sortField, sortDirection]);

  const deleteBatch = async () => {
    await currentUser.getIdToken().then(async (idToken) => {
      const url = serverUrl + "/documentClassification/deleteBatch";

      await axios.delete(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${idToken}`
        },
        data: {
          classificationId: classificationId,
          batchId: batchId
        }
      }).then((response) => {
        if (response.status === 200) {
          toast.success("Batch deleted successfully");
          setTimeout(() => {
            window.location.href = "/classifications/" + classificationId;
          }, 1000);
        } else {
          toast.error("Batch deletion failed");
        }
      }).catch((error) => {
        toast.error("Batch deletion failed");
        console.log(error);
      });
    });
  }

  const reloadFiles = async () => {
    await currentUser.getIdToken().then(async (idToken) => {
      const url = serverUrl + "/documentClassification/redoFile";

      await axios.post(url, {
        "classificationId": classificationId,
        "batchId": batchId,
        "fileIds": selectedFiles.map(file => file.id),
      }, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${idToken}`
        }
      }).then(async (response) => {
        if (response.status === 200) {
          await fetchClassification();
          toast.success("Files will be processed shortly");
        } else {
          toast.error("Files reprocessing failed");
        }
      }).catch((error) => {
        toast.error("Files reprocessing failed");
        console.log(error);
      });
    });
  }

  const reloadFile = async ({ fileId }) => {
    await currentUser.getIdToken().then(async (idToken) => {
      const url = serverUrl + "/documentClassification/redoFile";

      await axios.post(url, {
        "classificationId": classificationId,
        "batchId": batchId,
        "fileIds": [fileId],
      }, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${idToken}`
        }
      }).then(async (response) => {
        if (response.status === 200) {
          await fetchClassification();
          toast.success("File will be processed shortly");
        } else {
          toast.error("File reprocessing failed");
        }
      }).catch((error) => {
        toast.error("File reprocessing failed");
        console.log(error);
      });
    });
  }

  const deleteFile = async ({ fileId }) => {
    await currentUser.getIdToken().then(async (idToken) => {
      const url = serverUrl + "/documentClassification/deleteFiles";

      await axios.delete(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${idToken}`
        },
        data: {
          classificationId: classificationId,
          batchId: batchId,
          fileIds: [fileId]
        }
      }).then((response) => {
        if (response.status === 200) {
          toast.success("File deleted successfully");
          if (response.data.deleteAll) {
            //wait 1 second and change href to /classifications/classificationId
            setTimeout(() => {
              window.location.href = "/classifications/" + classificationId;
            }, 1000);
          }
        } else {
          toast.error("File deletion failed");
        }
      }).catch((error) => {
        toast.error("File deletion failed");
      });
    });
  }

  const deleteFiles = async () => {
    await currentUser.getIdToken().then(async (idToken) => {
      const url = serverUrl + "/documentClassification/deleteFiles";

      await axios.delete(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${idToken}`
        },
        data: {
          classificationId: classificationId,
          batchId: batchId,
          fileIds: selectedFiles.map(file => file.id)
        }
      }).then((response) => {
        if (response.status === 200) {
          toast.success("Files deleted successfully");
          if (response.data.deleteAll) {
            //wait 1 second and change href to /classifications/classificationId
            setTimeout(() => {
              window.location.href = "/classifications/" + classificationId;
            }, 1000);
          } else {
            setRefresh(!refresh);
            resetSelectedFiles();
          }
        } else {
          toast.error("Files deletion failed");
        }
      }).catch((error) => {
        toast.error("Files deletion failed");
      });
    });
    ;
  }

  const [open, setOpen] = useState(false);
  const [showEditClassificationModal, setShowEditClassificationModal] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [fileIdForExport, setFileIdForExport] = useState(null);

  function formatDate(dateString) {
    const options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
    return new Date(Number(dateString)).toLocaleDateString(undefined, options);
  }

  const openFileResult = async (file) => {
    //find the index of the file in the files array
    if (file.status === "waiting") {
      toast('File is still being processed', {
        icon: '⚠️',
      });
      return;
    } else if (file.status === "error") {
      toast.error("File processing failed");
      return;
    }
    const index = files.findIndex(f => f.id === file.id);
    setSelectedIndex(index);

    console.log(file);
    setShowFileBool(true);
  }

  const handleAdminSearch = () => {
    if (adminUserId.trim()) {
      setSearchedUserId(adminUserId.trim());
      // Add adminUserId to URL
      const queryParams = new URLSearchParams(location.search);
      queryParams.set('adminUserId', adminUserId.trim());
      history.replace(`${location.pathname}?${queryParams.toString()}`);
    }
  };

  const handleAdminSearchKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleAdminSearch();
    }
  };

  const handleClearSearch = () => {
    setAdminUserId('');
    setSearchedUserId('');
    // Remove adminUserId from URL
    const queryParams = new URLSearchParams(location.search);
    queryParams.delete('adminUserId');
    const newUrl = queryParams.toString()
      ? `${location.pathname}?${queryParams.toString()}`
      : location.pathname;
    history.replace(newUrl);
  };

  const pages = [
    {
      name: classification == null ? classificationId : classification.name,
      href: searchedUserId
        ? `/classifications/${classificationId}?adminUserId=${searchedUserId}`
        : `/classifications/${classificationId}`,
      current: false
    },
    {
      name: 'Batch ' + batchId,
      href: searchedUserId
        ? `/classifications/${classificationId}/batch/${batchId}?adminUserId=${searchedUserId}`
        : `/classifications/${classificationId}/batch/${batchId}`,
      current: true
    },
  ]

  const [isChangingTab, setIsChangingTab] = useState(false);

  const changeTab = (tab) => {
    if (tab === currentTab) return;

    setCurrentTab(tab);
    setCurrentPage(1);

    // unselect all files
    resetSelectedFiles();

    // Reset sorting when changing tabs
    setSortField(null);
    setSortDirection('desc');

    setIsChangingTab(true);
    setTimeout(() => {
      setIsChangingTab(false);
    }, 250);
  }

  const handleSelectAllFromCategory = () => {
    setSelectedFiles(allFilesFromCategory);
  }

  const handleExport = async () => {
    setIsExporting(true);
    let fileIds = [];

    if (fileIdForExport) {
      fileIds.push(fileIdForExport);
    } else {
      fileIds = selectedFiles.map(file => file.id);
    }

    console.log(fileIds);
    await currentUser.getIdToken().then(async (idToken) => {
      const url = serverUrl + "/documentClassification/exportResults";
      const loadingToastId = toast.loading('Exporting files...');
      await axios.post(url, {
        classificationId: classificationId,
        batchId: batchId,
        exportType: exportFormat,
        fileIds: fileIds
      }, {
        responseType: 'blob',
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${idToken}`
        },
      }).then((response) => {
        if (response.status === 200) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const a = document.createElement('a');
          a.href = url;
          a.download = `export_${new Date().toISOString().split('T')[0]}.${exportFormat === 'zip' ? 'zip' : 'xlsx'}`;
          document.body.appendChild(a);
          a.click();
          toast.success("File exported successfully", {
            id: loadingToastId,
          });

          // Cleanup
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
          setFileIdForExport(null);
          setShowExportModal(false);
          setIsExporting(false);
        } else {
          toast.error("File export failed", {
            id: loadingToastId,
          });
          setIsExporting(false);
        }
      }).catch((error) => {
        toast.error("File export failed", {
          id: loadingToastId,
        });
        setIsExporting(false);
        console.log(error);
      });
    });
  }

  return (
    <div className="">
      <Breadcrumb
        pages={pages}
        currentHref={searchedUserId ? `/classifications?adminUserId=${searchedUserId}` : "/classifications"}
      />

      <ErrorNotification showError={showError} setShowError={setShowError} />
      <GoodNotification showError={showSuccess} setShowError={setShowSuccess} />

      <ErrorNotificationCustom showError={showErrorCustom} setShowError={setShowErrorCustom} errorTitle={errorCustomTitle} errorSubtitle={errorCustomSubtitle} />
      <GoodNotificationCustom showError={showSuccessCustom} setShowError={setShowSuccessCustom} successfulTitle={successCustomTitle} successfulSubtitle={successCustomSubtitle} />

      <ShowDeleteModalBatch open={showDelete} setOpen={setShowDelete} deleteFunction={() => {
        deleteBatch();
        setShowDelete(false);
      }} />

      <ShowDeleteModalFile open={showDeleteFile} setOpen={setShowDeleteFile} deleteFunction={() => {
        deleteFile({ fileId: selectedFileIdDelete });
        setShowDeleteFile(false);
      }} />

      <ShowDeleteModalFiles open={showDeleteFiles} setOpen={setShowDeleteFiles} noOfFiles={selectedFiles.length} deleteFunction={() => {
        deleteFiles();
        setShowDeleteFiles(false);
      }} />

      <ShowRedoModalFiles open={showRedoFiles} setOpen={setShowRedoFiles} noOfFiles={selectedFiles.length} redoFunction={async () => {
        await reloadFiles();
        setShowRedoFiles(false);
        resetSelectedFiles();
      }} />

      <UploadFilesModal
        open={open}
        onOpenChange={setOpen}
        currentBatchId={batchId}
        classificationId={classificationId}
      />

      <ModalForViewFile open={showFileBool} setOpen={setShowFileBool} >
        <ViewFile
          closeModal={() => {
            setShowFileBool(false);
            setSelectedIndex(null);
          }}
          classificationId={classificationId}
          classification={classification}
          batchId={batchId}
          fileIds={files.map(file => file.id)}
          firstIndex={selectedIndex}
        />
      </ModalForViewFile>

      <ExportDialog
        open={showExportModal}
        setOpen={setShowExportModal}
        exportFormat={exportFormat}
        setExportFormat={setExportFormat}
        handleExport={handleExport}
        noOfFiles={selectedFiles.length}
        isOneFile={fileIdForExport}
        isExporting={isExporting}
      />


      <div className="">
        {classification?.batches && (
          <BatchHeading
            batchName={(classification?.batches[batchId]?.name ? "Batch " + classification?.batches[batchId]?.name : "Batch")}
            batchCreatedAt={formatDate(classification?.batches[batchId]?.startTime)}
            batchUpdatedAt={formatDate(classification?.batches[batchId]?.startTime)}
            batchFilesCount={tabs[0]?.count}
            documentTypesCount={classification?.documentTypes?.length}
            batchOrigin={extraction?.batches[batchId]?.origin}
            deleteBatch={() => setShowDelete(true)}
            editClassification={() => setShowEditClassificationModal(true)}
            classificationId={classificationId}
            batchId={batchId}
          />
        )}
      </div>

      <EditClassificationModal
        open={showEditClassificationModal}
        onOpenChange={setShowEditClassificationModal}
        currentClassificationData={classification}
      />

      {/* Admin Search */}
      {isAdmin && (
        <div className="mt-6 bg-indigo-50 border border-indigo-200 rounded-lg p-4">
          <div className="flex items-center gap-2">
            <span className="inline-flex items-center rounded-md bg-indigo-100 px-2 py-1 text-xs font-medium text-indigo-700">
              Admin
            </span>
            <h3 className="text-sm font-semibold text-indigo-900">View files for any user</h3>
          </div>
          <div className="mt-3 flex flex-wrap items-center gap-2">
            <input
              type="text"
              value={adminUserId}
              onChange={(e) => setAdminUserId(e.target.value)}
              onKeyPress={handleAdminSearchKeyPress}
              placeholder="Enter User ID"
              className="flex-1 min-w-[200px] text-sm border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
            <button
              onClick={handleAdminSearch}
              disabled={!adminUserId.trim()}
              className="inline-flex items-center gap-x-1.5 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <Search className="h-4 w-4" />
              Search
            </button>
            {searchedUserId && (
              <button
                onClick={handleClearSearch}
                className="inline-flex items-center gap-x-1.5 rounded-md bg-gray-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500"
              >
                Clear
              </button>
            )}
          </div>
          {searchedUserId && (
            <p className="mt-2 text-sm text-indigo-700">
              Viewing files for user: <span className="font-mono font-semibold">{searchedUserId}</span>
            </p>
          )}
        </div>
      )}

      <div className="sm:flex sm:items-center mt-7">
        <div className="sm:flex-auto">
          <h3 className="text-base font-semibold leading-6 text-gray-900">Files</h3>
          <p className="mt-1 text-sm text-gray-500">
            A list of all files uploaded to this batch.
          </p>
        </div>

        <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
          <button
            onClick={() => setOpen(true)}
            className="ml-2 inline-flex items-center gap-x-1.5 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            <PlusIcon className="-ml-0.5 h-5 w-5" aria-hidden="true" />
            Add files
          </button>
        </div>
      </div>

      <div className="mt-5 overflow-y-auto max-h-[200px]">
        <SelectFileStatus
          tabs={tabs}
          currentTab={currentTab}
          changeTab={changeTab}
        />
      </div>

      <div className="mt-2 flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto overflow-y-hidden sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <div className="relative">
              {selectedFiles.length > 0 && (
                <div className="absolute left-14 top-0 flex h-12 items-center space-x-3 bg-white sm:left-12">
                  <button
                    type="button"
                    className="inline-flex items-center rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-white"
                  >
                    {selectedFiles.length} {selectedFiles.length > 1 ? 'files' : 'file'} selected
                  </button>
                  <button
                    onClick={() => handleSelectAllFromCategory()}
                    type="button"
                    className="inline-flex items-center rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-white"
                  >
                    Select all from category
                  </button>
                  {!checked && (
                    <button
                      type="button"
                      onClick={() => setShowRedoFiles(true)}
                      className="inline-flex items-center rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-white"
                    >
                      Redo {selectedFiles.length > 1 ? 'files' : 'file'}
                    </button>)}
                  {checked && (
                    <button
                      type="button"
                      onClick={() => setShowRedoFiles(true)}
                      className="inline-flex items-center rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-white"
                    >
                      Redo {selectedFiles.length > 1 ? 'files' : 'file'}
                    </button>)}
                  <button
                    type="button"
                    onClick={() => setShowDeleteFiles(true)}
                    className="inline-flex items-center rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-white"
                  >
                    Delete
                  </button>
                  <Menu as="div" className="relative inline-block text-left overflow-visible">
                    <div className='z-50' onClick={() => {
                      setFileIdForExport(null);
                      setShowExportModal(true);
                    }}>
                      <Menu.Button className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                        Export As
                        <ChevronRightIcon className="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
                      </Menu.Button>
                    </div>
                  </Menu>
                </div>
              )}

              <table className={classNames("min-w-full table-fixed divide-y divide-gray-300",
                files.length <= 0 ? 'hidden' : ''
              )}>
                <thead>
                  <tr>
                    <th
                      scope="col"
                      className={classNames("relative px-7 sm:w-12 sm:px-6", (isChangingTab || files.length <= 0) ? 'hidden' : '')}
                    >
                      <input
                        type="checkbox"
                        className="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                        ref={checkbox}
                        checked={checked}
                        onChange={toggleAll}
                      />
                    </th>
                    <th scope="col" className="py-2.5 pr-3 text-left text-sm font-semibold text-gray-900">
                      {isChangingTab && <Skeleton width={80} height={20} className="" />}
                      {!isChangingTab && "File name".toUpperCase()}
                    </th>
                    <th scope="col" className="px-3 py-2.5 text-left text-sm font-semibold text-gray-900">
                      {isChangingTab && <Skeleton width={80} height={20} className="" />}
                      {!isChangingTab && "Status".toUpperCase()}
                    </th>
                    <th scope="col" className="px-3 py-2.5 text-left text-sm font-semibold text-gray-900">
                      {isChangingTab && <Skeleton width={80} height={20} className="" />}
                      {!isChangingTab && "Document Type".toUpperCase()}
                    </th>
                    <th scope="col" className="px-3 py-2.5 text-left text-sm font-semibold text-gray-900">
                      {isChangingTab && <Skeleton width={80} height={20} className="" />}
                      {!isChangingTab && (
                        <button
                          onClick={() => handleSort('confidence')}
                          className="group inline-flex items-center hover:text-gray-700 hover:bg-gray-50 px-2 py-1 rounded transition-colors duration-150"
                        >
                          {"Confidence".toUpperCase()}
                          <span className="ml-2 flex-none rounded text-gray-500">
                            {sortField === 'confidence' ? (
                              sortDirection === 'desc' ? (
                                <SortChevronDownIcon className="h-4 w-4 text-indigo-700 font-bold" aria-hidden="true" />
                              ) : (
                                <ChevronUpIcon className="h-4 w-4 text-indigo-700 font-bold" aria-hidden="true" />
                              )
                            ) : (
                              <div className="relative h-4 w-4">
                                <ChevronUpIcon className="absolute top-0 h-2.5 w-4" aria-hidden="true" />
                                <SortChevronDownIcon className="absolute bottom-0 h-2.5 w-4" aria-hidden="true" />
                              </div>
                            )}
                          </span>
                        </button>
                      )}
                    </th>
                    <th scope="col" className="px-3 py-2.5 text-left text-sm font-semibold text-gray-900">
                      {isChangingTab && <Skeleton width={80} height={20} className="" />}
                      {!isChangingTab && "Extraction".toUpperCase()}
                    </th>
                    {selectedFiles.length <= 0 &&
                      <th scope="col" className="relative py-2.5 pl-3 pr-4 sm:pr-3">
                        <span className="sr-only">Edit</span>
                      </th>
                    }
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {isChangingTab && (
                    <tr>
                      <td colSpan="6" className="py-8">
                        <Skeleton className='mb-3' height={20} count={itemsPerPage} />
                      </td>
                    </tr>
                  )}

                  {!isChangingTab && files.map((file, index) => (
                    <tr key={file.id} className={selectedFiles.includes(file) ? 'bg-gray-50' : undefined}>
                      <td className="relative px-7 sm:w-12 sm:px-6">
                        {selectedFiles.includes(file) && (
                          <div className="absolute inset-y-0 left-0 w-0.5 bg-indigo-600" />
                        )}
                        <input
                          type="checkbox"
                          className="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                          value={file.id}
                          checked={selectedFiles.includes(file)}
                          onChange={(e) =>
                            setSelectedFiles(
                              e.target.checked
                                ? [...selectedFiles, file]
                                : selectedFiles.filter((p) => p !== file)
                            )
                          }
                        />
                      </td>
                      <td
                        className={classNames(
                          'whitespace-nowrap py-4 pr-3 text-sm font-medium',
                          selectedFiles.includes(file) ? 'text-indigo-600' : 'text-gray-900'
                        )}
                      >
                        <div className='flex items-center group'>
                          <button onClick={() => {
                            openFileResult(file)
                          }}>
                            <span className='group-hover:underline group-hover:text-indigo-600 mr-1.5 cursor-pointer'>
                              {file.name}
                            </span>
                          </button>
                          <button
                            onClick={() => openFileResult(file)}
                            className="inline-flex items-center justify-center h-6 w-6 rounded-full text-gray-400 group-hover:text-gray-500 focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-indigo-500"
                          >
                            <FontAwesomeIcon icon={IconEdit} />
                          </button>
                        </div>
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500" >
                        <span className='text-red-300'>
                          {file.status === 'error' ? 'error' : ''}
                          {file.status === 'error' ? (
                            file.errorMessage !== undefined ? (': ' + file.errorMessage) : ''
                          ) : ''}
                        </span>
                        <span className='text-orange-300'>
                          {file.status === 'waiting' ? 'processing' : ''}
                        </span>
                        <span className=''>
                          {file.status === 'processed' ? 'processed' : ''}
                        </span>
                        <span className=''>
                          {file.status === 'confirmed' ? 'confirmed' : ''}
                        </span>
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500" >
                        {file.result?.documentType ? (
                          <div
                            className={`inline-flex items-center rounded-full border px-2 py-0.5 text-sm font-medium`}>
                            {file.result?.documentType}
                          </div>
                        ) : (
                          <div className="inline-flex items-center px-2 py-0.5 text-sm font-medium">
                            -
                          </div>
                        )}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500" >
                        {file.result?.confidence !== undefined ? (
                          <div
                            className={`inline-flex items-center rounded-full border px-2 py-0.5 text-sm font-medium
                            ${file.result?.confidence >= 0.9
                                ? "text-green-700 border-green-200"
                                : file.result?.confidence >= 0.8
                                  ? "text-amber-700 border-amber-200"
                                  : "text-red-700 border-red-200"
                              }`}
                          >
                            {file.result?.confidence * 100 + "%"}
                          </div>
                        ) : (
                          <div className="inline-flex items-center px-2 py-0.5 text-sm font-medium">
                            -
                          </div>
                        )}
                      </td>
                      {file.extraction.errorMessage || file.extraction.extractionId ? (
                        <td className="pl-2" >
                          <div className="col-span-2 flex items-center">
                            <div>
                              {file.extraction.extractionId && file.extraction.name && (
                                <div
                                  className={`inline-flex items-center rounded-full px-2 py-0.5 text-sm font-medium mb-1 bg-gray-100`}
                                >
                                  {file.extraction.name.length > 40 ? (
                                    <span title={file.extraction.name}>
                                      {file.extraction.name.substring(0, 40)}...
                                    </span>
                                  ) : file.extraction.name}
                                </div>
                              )}
                              <div className="flex items-center text-xs">
                                {file.extraction.status === "processed" ? (
                                  <>
                                    <CheckCircle className="h-3 w-3 text-green-600 mr-1" />
                                    <span className="text-green-600">Completed</span>
                                  </>
                                ) : file.extraction.status === "waiting" ? (
                                  <>
                                    <AlertCircle className="h-3 w-3 text-amber-600 mr-1" />
                                    <span className="text-amber-600">In Progress</span>
                                  </>
                                ) : (
                                  <>
                                    <AlertCircle className="h-4 w-4 text-red-600 mr-1" />
                                    <span className="text-red-600 text-sm">{file.extraction.errorMessage || 'Error'}</span>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </td>
                      ) : file.result?.documentType === 'other' || file.status === "waiting" ? (
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500" >

                        </td>
                      ) : (
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500" >
                          No extraction linked
                        </td>
                      )
                      }

                      {selectedFiles.length <= 0 &&
                        <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-3 relative">
                          <DropdownWithDividerAndIcons
                            className="overflow-visible"
                            file={file}
                            exportAs={() => {
                              setFileIdForExport(file.id);
                              setShowExportModal(true);
                            }}
                            reloadFile={reloadFile}
                            deleteFile={({ fileId }) => {
                              setShowDeleteFile(true);
                              setSelectedFileIdDelete(fileId);
                            }}
                            initialButton={
                              <Menu.Button className="flex items-center">
                                <span className="text-indigo-600 hover:text-indigo-900">
                                  Options<span className="sr-only">, {file.name}</span>
                                </span>
                              </Menu.Button>
                            }
                          />
                        </td>
                      }
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Show a message if there are no files */}
              {!isChangingTab && files.length <= 0 && currentTab === 'All' &&
                <div className="mt-4 flex-1 flex flex-col items-center justify-center h-full rounded-lg bg-gray-100 p-12">
                  <div className="text-center">
                    <h2 className="text-xl font-semibold text-gray-900">No files yet</h2>
                    <p className="mt-1.5 text-sm text-gray-600">
                      Upload files to this batch.
                    </p>
                    <button
                      onClick={() => setOpen(true)}
                      className="mt-3 ml-2 inline-flex items-center gap-x-1.5 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      <PlusIcon className="-ml-0.5 h-5 w-5" aria-hidden="true" />
                      Add files
                    </button>
                  </div>
                </div>
              }
              {files.length <= 0 && !isChangingTab && currentTab !== 'All' && (
                <div className="mt-4 flex-1 flex flex-col items-center justify-center h-full rounded-lg bg-gray-100 p-16">
                  <div className="text-center">
                    <h2 className="text-xl font-semibold text-gray-900">There are no files with this status</h2>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {
        files.length > 0 && (
          <Pagination
            numberOfPages={noOfPages}
            currentPageNumber={currentPage}
            previousButton={previousPage}
            nextButton={nextPage}
            selectPage={selectPage}
            itemsPerPage={itemsPerPage}
            setItemsPerPage={setItemsPerPage}
          />)
      }
    </div >
  )
}

function ExportDialog({ open, setOpen, exportFormat, setExportFormat, handleExport, noOfFiles, isOneFile, isExporting }) {
  const cancelButtonRef = useRef(null);

  return open && (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-100" initialFocus={cancelButtonRef} onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-100 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                <div className="bg-white rounded-lg shadow-lg w-full max-w-lg p-6">
                  <h2 className="text-xl font-semibold mb-4">Export Options</h2>

                  <div className="space-y-4 mb-2">
                    <div className="space-y-2">
                      <label className="block text-sm font-medium text-gray-700">File Format</label>
                      <div className="flex space-x-2">
                        <button
                          className={`flex-1 px-4 py-2 border rounded-md ${exportFormat === 'excel' ? 'bg-indigo-600 text-white border-indigo-600' : 'border-gray-300'
                            }`}
                          onClick={() => setExportFormat('excel')}
                        >
                          Excel
                        </button>
                        <button
                          className={`flex-1 px-4 py-2 border rounded-md ${exportFormat === 'zip' ? 'bg-indigo-600 text-white' : 'border-gray-300'
                            }`}
                          onClick={() => setExportFormat('zip')}
                        >
                          ZIP
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="mt-4 text-sm text-gray-600">
                    {isOneFile ? (
                      <p>You are about to export 1 file.</p>
                    ) : (
                      <p>You are about to export {noOfFiles} {noOfFiles === 1 ? 'file' : 'files'}.</p>
                    )}
                  </div>
                </div>
                {/* Footer */}
                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                  <button
                    type="button"
                    className={`inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-sm sm:ml-3 sm:w-auto bg-indigo-600 text-white hover:bg-indigo-500 ${isExporting ? 'opacity-50 cursor-not-allowed' : ''}`}
                    onClick={handleExport}
                    disabled={isExporting}
                  >
                    Export {isOneFile ? 'file' : noOfFiles > 1 ? 'files' : 'file'}
                  </button>
                  <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    ref={cancelButtonRef}
                    onClick={() => setOpen(false)}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}